import { Checkbox } from "primereact/checkbox";
import ErrorMessage from "./ErrorMessage";
import { useFormikContext, getIn } from "formik";

export type CustomCheckboxProps = {
  label: string;
  id: string;
  [key: string]: any;
};

const CustomCheckbox = ({ label, id, ...props }: CustomCheckboxProps) => {
  const formik = useFormikContext<any>();

  return (
    <div className="flex flex-column gap-2 mb-2">
      <div className="flex flex-row gap-2">
        <Checkbox
          id={id}
          inputId={`cb-${id}`}
          checked={getIn(formik.values, id)}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          {...props}
        />
        <label htmlFor={`cb-${id}`}>{label}</label>
      </div>
      <ErrorMessage id={id} formik={formik} />
    </div>  
  );
};

export default CustomCheckbox;
